module.exports = __webpack_public_path__ + "static/a9-264c57776c6b500206249b52d25a6a74.png";